export const pembelajaranKelas = "Pembelajaran Kelas";
export const pramuka = "Pramuka";